'use client'

import { Teams } from '@glovo/organisation'
import type { FC } from 'react'
import React from 'react'
import { AddressTypeMap } from './address-type-map/AddressTypeMap'
import styles from './AddressTypeForm.module.scss'
import { useAuth } from '@/tools/auth'
import { useLocalisation } from '@/tools/i18n/client'
import { withErrorBoundary } from '@/tools/o11y/client'
import { BenchIcon, BuildingsIcon, Button, HouseIcon, MonitorIcon } from '@/tools/ui'
import { useAddressBookContext } from '@/user/address-book/AddressBookContext'
import type { UserAddressKind } from '@/user/address-book/entities'
import { TitleDesktop } from '@/user/address-book/ui/components/title-desktop/TitleDesktop'

export const AddressTypeFormComponent: FC = () => {
  const { navigate, setAddress, addressData, isMobile } = useAddressBookContext()
  const { t } = useLocalisation()
  const { isLoggedIn } = useAuth()

  const handleClick = (addressKind: UserAddressKind) => {
    setAddress({ ...addressData, kind: addressKind })
    navigate('onNext')
  }

  const handleNavigateBack = () => {
    if (isLoggedIn) {
      navigate('onBack')
    } else {
      navigate('onBackToFindByText')
    }
  }

  return (
    <div className={styles.addressTypeForm}>
      {isMobile ? (
        <h3 className={styles.titleMobile}>{t('address-list.what-kind-of-place-is-this')}</h3>
      ) : (
        <>
          <TitleDesktop
            title={t('address-list.what-kind-of-place-is-this')}
            onBackClick={handleNavigateBack}
          />
          <AddressTypeMap />
        </>
      )}

      <div className={styles.optionContainer}>
        <Button
          className={styles.option}
          label={t('address-type.house')}
          leadingIcon={HouseIcon}
          size="l"
          variant="neutral"
          onClick={() => handleClick('HOUSE')}
        />
        <Button
          className={styles.option}
          label={t('address-type.apartment')}
          leadingIcon={BuildingsIcon}
          size="l"
          variant="neutral"
          onClick={() => handleClick('APARTMENT')}
        />
        <Button
          className={styles.option}
          label={t('address-type.office')}
          leadingIcon={MonitorIcon}
          size="l"
          variant="neutral"
          onClick={() => handleClick('OFFICE')}
        />
        <Button
          className={styles.option}
          label={t('address-type.other')}
          leadingIcon={BenchIcon}
          size="l"
          variant="neutral"
          onClick={() => handleClick('OTHER')}
        />
      </div>
    </div>
  )
}

export const AddressTypeForm = withErrorBoundary(AddressTypeFormComponent, {
  id: 'user.address_book.step.address_type_form',
  owner: Teams.WEB,
})
